// extracted by mini-css-extract-plugin
export default {"placeholder":"index_placeholder_xoL8A","wrap":"index_wrap_hHbjJ","content":"index_content_T3TU6"};